<template>

  <div class="p-groups-admin">
    <page-title>Interest Groups</page-title>

    <section-block>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button :primary="true" @click="$router.push({name: 'GroupCreate'})">New Interest Group</base-button>
      </template>

      <vuetable
        class="c-data-table"
        :api-mode="false"
        :fields="table.fields"
        :data="collection"
        @vuetable:row-clicked="onRowClicked"
      ></vuetable>
      <!-- <loading></loading> -->
    </section-block>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupActions from "@/components/GroupActions";

export default {
  name: 'groups-admin',

  data() {
    return {
      table: {
        fields: [
          {
            name: 'name',
            title: 'Group Name',
            width: "50%"
          },
          {
            name: 'created_time',
            title: 'Date Created',
            width: '30%',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            formatter(val) {
              // TODO: For some reason datejs isn't working
              const dateBits = val.split(' ')[0]
              const date = new Date(dateBits);
              let month = date.getMonth()+1;
              if (month < 10) {
                month = `0${month}`;
              }
              return `${date.getUTCDate()}/${month}/${date.getFullYear()}`;
            }
          },
          {
            name: GroupActions,
            title: "Actions",
            width: "20%"
          }
        ],
      },
    };
  },

  beforeCreate() {
    this.$store.dispatch('InterestGroups/list');
    // we should clear localstorage entries for groups?
    this.$store.dispatch('InterestGroups/getUserInterestGroups', true);

  },



  methods: {
    onRowClicked(dataItem) {
      if (this.$route.params.isAdmin && (dataItem.event.target.localName === 'td' || dataItem.event.target.parentNode.localName === 'td')) {
      this.$store.dispatch('InterestGroups/setCurrentGroup', dataItem.data);
      this.$router.push({
        name: 'GroupEdit',
        params: { groupId: dataItem.data.id },
      });
      }
    },
  },

  computed: {
    ...mapState('InterestGroups',['collection'])
  },
};
</script>
